var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "travel-rating" }, [
    _c("div", { staticClass: "star-rating" }, [
      _c(
        "div",
        { staticClass: "star-rating-icons" },
        _vm._l(5, function (index) {
          return _c("i", { key: index, staticClass: "icon icon-star" })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "star-rating-icons-overlay" },
        [
          _vm._l(parseInt(_vm.rating / 2), function (index) {
            return _c("i", { key: index, staticClass: "icon icon-star" })
          }),
          _vm._v(" "),
          (_vm.rating / 2) % 1 >= 0.3
            ? _c("i", { staticClass: "icon icon-star-half" })
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "bold-link",
        attrs: {
          title: "",
          "data-fancybox": "reviews",
          "data-src": "#bewertungen-modal",
          href: "#bewertungen-modal",
        },
      },
      [
        _vm.numReviews == 1
          ? _c("strong", [_vm._v(_vm._s(_vm.numReviews) + " Bewertung")])
          : _c("strong", [_vm._v(_vm._s(_vm.numReviews) + " Bewertungen")]),
      ]
    ),
    _vm._v(" "),
    _vm.recommendationRate
      ? _c("p", [
          _c("strong", [_vm._v(_vm._s(_vm.recommendationRate) + "%")]),
          _vm._v(" empfehlen diese Reise weiter"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.renderFancybox
      ? _c(
          "div",
          {
            staticStyle: { display: "none" },
            attrs: { id: "bewertungen-modal" },
          },
          [
            _c("div", { staticClass: "ccm-page" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "travel-rating-modal" }, [
                  _c("div", { staticClass: "travel-rating-summary well" }, [
                    _c("h2", [_vm._v(_vm._s(_vm.title))]),
                    _vm._v(" "),
                    _c("h3", [
                      _c("div", { staticClass: "star-rating" }, [
                        _c(
                          "div",
                          { staticClass: "star-rating-icons" },
                          _vm._l(5, function (index) {
                            return _c("i", {
                              key: index,
                              staticClass: "icon icon-star",
                            })
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "star-rating-icons-overlay" },
                          [
                            _vm._l(parseInt(_vm.rating / 2), function (index) {
                              return _c("i", {
                                key: index,
                                staticClass: "icon icon-star",
                              })
                            }),
                            _vm._v(" "),
                            (_vm.rating / 2) % 1 >= 0.3
                              ? _c("i", { staticClass: "icon icon-star-half" })
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-count-text" }, [
                        _vm._v(
                          _vm._s(_vm.numReviews) + " Bewertungen der Reisenden"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.recommendationRate
                      ? _c("div", { staticClass: "travel-recommend-rating" }, [
                          _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.recommendationRate) + "%"),
                            ]),
                            _vm._v(
                              " empfehlen diese Reise weiter\n              "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "travel-rating-groups",
                        attrs: { id: "bewertungen-collapse-modal" },
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(_vm.summary, function (s) {
                                return _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-md-6" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "travel-group-rating row",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-12 col-sm-7" },
                                          [
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(_vm._s(s.bezeichnung)),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-12 col-sm-5" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "star-rating" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "star-rating-icons",
                                                  },
                                                  _vm._l(5, function (index) {
                                                    return _c("i", {
                                                      key: index,
                                                      staticClass:
                                                        "icon icon-star",
                                                    })
                                                  }),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "star-rating-icons-overlay",
                                                  },
                                                  [
                                                    _vm._l(
                                                      parseInt(s.bewertung / 2),
                                                      function (index) {
                                                        return _c("i", {
                                                          key: index,
                                                          staticClass:
                                                            "icon icon-star",
                                                        })
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    (s.bewertung / 2) % 1 >= 0.3
                                                      ? _c("i", {
                                                          staticClass:
                                                            "icon icon-star-half",
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "col-xs-12 col-sm-12 col-md-4",
                          }),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "travelReviewFilterForm" } }, [
                    _c(
                      "div",
                      { staticClass: "row travel-rating-filter-wrapper" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-5 col-md-4 col-lg-2",
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.starFilter,
                                      expression: "starFilter",
                                    },
                                  ],
                                  staticClass: "form-control select2 input-sm",
                                  attrs: {
                                    id: "travel-rating-filter",
                                    name: "travelRatingFilter",
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.starFilter = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(
                                      "Alle (" + _vm._s(_vm.reviewCount) + ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "5",
                                        disabled: _vm.starCount5 === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "5 Sterne (" +
                                          _vm._s(_vm.starCount5) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "4",
                                        disabled: _vm.starCount4 === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "4 Sterne (" +
                                          _vm._s(_vm.starCount4) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "3",
                                        disabled: _vm.starCount3 === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "3 Sterne (" +
                                          _vm._s(_vm.starCount3) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "2",
                                        disabled: _vm.starCount2 === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "2 Sterne (" +
                                          _vm._s(_vm.starCount2) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "1",
                                        disabled: _vm.starCount1 === 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "1 Stern (" +
                                          _vm._s(_vm.starCount1) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "travel-reviews" },
                      _vm._l(_vm.reviewsFiltered, function (r, index) {
                        return _c("travel-review-item", {
                          key: index,
                          attrs: {
                            name: r.name,
                            index: index,
                            date: r.erstelldatum,
                            title: r.titel,
                            text: r.text,
                            comment: r.comment,
                            "rating-avg": parseFloat(r.bewertung),
                            "detail-ratings": r.details,
                          },
                        })
                      }),
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-7 col-md-8 col-lg-10" }, [
      _c("h3", [_vm._v("Einzelbewertungen")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }